// This file is auto-generated by 'scripts/generateIconComponents.ts'. Do not edit it manually.

import { Icon, type IconProps } from '@chakra-ui/react/icon';
import { type Ref } from 'react';

import SVG16 from '../svgs/16x16/icon-info-circle-16.svg?react';
import SVG24 from '../svgs/24x24/icon-info-circle-24.svg?react';
import { bitkitIcon } from './bitkitIcon';

export interface IconInfoCircleProps extends IconProps {
  size?: '16' | '24';
}

const IconInfoCircle = bitkitIcon(function IconInfoCircle(
  { size = '24', ...props }: IconInfoCircleProps,
  ref: Ref<SVGSVGElement>,
) {
  if (size === '16') {
    return (
      <Icon asChild ref={ref} {...props}>
        <SVG16 width="16" height="16" />
      </Icon>
    );
  }

  return (
    <Icon asChild ref={ref} {...props}>
      <SVG24 width="24" height="24" />
    </Icon>
  );
});

IconInfoCircle.displayName = 'IconInfoCircle';

export default IconInfoCircle;
